import React from 'react';
import { withRouter } from 'react-router-dom';
import { FlexColumn } from 'styles/Layout';
import styled from 'styled-components';
import InfoSection from 'modules/external_tenant/components/index/InfoSectionComponent';
import BenefitsSection from 'modules/external_tenant/components/index/benefits_section/BenefitsSectionComponent';
import FormsSection from 'modules/external_tenant/components/index/FormsSectionComponent';
import { media } from 'styles/Mixins';
import { PrimaryButton } from 'styles/Buttons';

const Container = styled.div`
  position: relative;
  display: block;
`;

const AccessContainer = styled(FlexColumn)`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 89px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 6px 0 rgba(0, 0, 0, 0.12);
  padding: 0 16px;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? '1' : '0')};
  transition: all 0.1s linear;
  ${media.sm`
    display: none;
  `};
`;

const AccessText = styled.span`
  min-height: 15px;
  color: #4a4a4a;
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
  text-align: center;
  margin: 18px auto 10px;
`;

const AccessButton = styled(PrimaryButton)`
  width: 100%;
  max-width: 293px;
`;

type StateType = {
  showAccess: boolean
};

type PropsType = {
  isHomeAppComplete?: boolean
};

class Index extends React.Component<PropsType, StateType> {
  static defaultProps = {
    isHomeAppComplete: false
  };

  wrapperElement = null;

  state = {
    showAccess: true
  };

  componentDidMount() {
    this.wrapperElement = document.getElementById('Wrapper');
    this.checkPosition();
    this.wrapperElement.addEventListener('scroll', this.checkPosition, {
      passive: true
    });
  }

  componentWillUnmount() {
    this.wrapperElement.removeEventListener('scroll', this.checkPosition);
  }

  checkPosition = () => {
    const scrollPosition =
      this.wrapperElement.scrollTop + this.wrapperElement.offsetHeight;
    if (scrollPosition >= this.wrapperElement.scrollHeight - 120) {
      this.setState({ showAccess: false });
    } else if (!this.state.showAccess) {
      this.setState({ showAccess: true });
    }
  };

  moveToBottom = () => {
    this.wrapperElement.scrollTo({
      top: this.wrapperElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  render() {
    const { showAccess } = this.state;
    return (
      <Container>
        <FlexColumn>
          <InfoSection />
          <BenefitsSection />
        </FlexColumn>
        <FormsSection {...this.props} />
        <AccessContainer
          alignItems="center"
          isVisible={!this.props.isHomeAppComplete}
          show={showAccess}
        >
          <AccessText>
            ¡Solicitud de renta en línea en menos de 10 minutos!
          </AccessText>
          <AccessButton onClick={this.moveToBottom}>
            Quiero ser un inquilino Homie
          </AccessButton>
        </AccessContainer>
      </Container>
    );
  }
}

export default withRouter(Index);
